const es = "es-ES";

export const fmtInt = (n: number) => n.toLocaleString(es, { maximumFractionDigits: 0 });

/** Tokens: 1.234 → "1,2 k"; 4.200.000 → "4,2 M". */
export function fmtTokens(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toLocaleString(es, { maximumFractionDigits: 1 })} M`;
  if (n >= 1_000) return `${(n / 1_000).toLocaleString(es, { maximumFractionDigits: 1 })} k`;
  return String(Math.round(n));
}

export function fmtMoney(m: { amount: number; currency: string } | null | undefined, digits = 2): string {
  if (!m) return "—";
  try {
    return m.amount.toLocaleString(es, { style: "currency", currency: m.currency, minimumFractionDigits: digits, maximumFractionDigits: Math.max(digits, m.amount < 1 ? 4 : digits) });
  } catch {
    return `${m.amount.toFixed(digits)} ${m.currency}`;
  }
}

export function relTime(iso: string | Date | null | undefined, now = Date.now()): string {
  if (!iso) return "—";
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 45) return "ahora";
  const m = Math.round(s / 60);
  if (m < 60) return `hace ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.round(h / 24);
  return d === 1 ? "ayer" : `hace ${d} d`;
}

export const fmtDateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString(es, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null) return "—";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  return m < 60 ? `${m} min ${s % 60 ? `${s % 60} s` : ""}`.trim() : `${Math.floor(m / 60)} h ${m % 60} min`;
}

export const shortSha = (s: string | null | undefined) => (s ? s.slice(0, 7) : "—");
